import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";

import Label from "../../components/label";
import Section from "../../components/section";
import Button from "../../components/Buttons";

import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";
import ImageUploader from "../../components/upload-image";
import Input, { FormikInput } from "../../components/input";
import { Formik, Form } from "formik";

import { Accordion } from "react-bootstrap";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    getBlogsQuery,
    handleEditClick,
    handleWorkDelete,
    handleAddBlogClick,
    handleOnChange,
    initialValues,
    handleSubmit,
  } = useBlogsProvider();

  return (
    <Section>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Meta Title"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.meta_title"
                        rootClassName="w-full"
                      />
                    </div>

                    <div className="flex flex-col">
                      <Label
                        label="Meta Keywords"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.keywords"
                        rootClassName="w-full"
                        className="h-[26rem]"
                      />
                    </div>
                    <div className="flex flex-col ">
                      <Label
                        label="Meta Description"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.meta_description"
                        rootClassName="w-full"
                        className="h-[26rem]"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Blogs</Accordion.Header>
                <Accordion.Body>
                  <div className="flex items-center justify-between gap-4">
                    <Input
                      onChange={handleOnChange}
                      placeholder="Search Blog"
                      className="flex-1"
                    />
                    <div
                      className="bg-[black] p-1 rounded-full w-auto cursor-pointer"
                      onClick={handleAddBlogClick}>
                      <Plus className="text-[white]" />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto mb-10">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Blog Heading
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Keywords
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[120px]">
                            Banner Image
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[70px]">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {getBlogsQuery?.data?.data?.map((item, index) => (
                          <tr key={index}>
                            <td className="border border-gray-300 px-2 py-2">
                              <Label
                                className="mb-0 text-black text-[15px]"
                                label={item.title}
                              />
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              <Label
                                className="mb-0 text-black text-[15px]"
                                label={item.keywords?.join(", ")}
                              />
                            </td>
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              <ImageUploader
                                imgStyle={{ width: "6rem" }}
                                imageUrl={item.banner_img}
                              />
                            </td>
                            <td className="flex justify-between border border-gray-300 bg-white text-center py-4">
                              <Pencil
                                className="ml-4 cursor-pointer"
                                onClick={() => handleEditClick(item)}
                              />
                              <Trash
                                className="mr-4 cursor-pointer"
                                onClick={() => handleWorkDelete(item)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="absolute bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
              <Button type="button" onClick={() => { handleSubmit(values) }}>Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
